import * as Yup from "yup";

const ProductGenderSizeSchema = () => Yup.object().shape({
  product_id: Yup
    .number()
    .label("Product")
    .required(),
  gender_id: Yup
    .number()
    .label("Gender")
    .required(),
  product_size_id: Yup
    .number()
    .label("Size")
    .required(),
});

export default ProductGenderSizeSchema;
